import React, { useState, useEffect } from 'react'
import _, { each } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import SpinnerLoading from 'components/Loading/SpinnerLoading'
import * as actions from '../../../../redux/actions'
import { useTranslation } from 'react-i18next'
import EditTokenLine from './EditTokenLine'

export default function EditNotify() {
  const { t } = useTranslation()
  const stations = useSelector((state) => state.station)
  const dispatch = useDispatch()
  const [allowedDashboard, setAllowedDashboard] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const me = useSelector((state) => state.me)

  useEffect(() => {
    dispatch(actions.stationAll()).then(() => {
      dispatch(actions.systemInfoGet()).then(() => {
        setIsLoading(true)
      })
    })
    return () => {}
  }, [])

  useEffect(() => {
    if (me && me._id) {
      if (_.size(stations.arr)) {
        if (_.includes(me.duty, 'ALLAREA')) {
          let allowedStationStack = stations.arr
          setAllowedDashboard(allowedStationStack)
        } else {
          let allowedStation = _.filter(
            stations.arr,
            (station, index) => station._id === me.duty[index]
          )
          setAllowedDashboard(allowedStation)
        }
      }
    }
    return () => {}
  }, [stations, me])

  return (
    <div className="relative flex flex-col min-w-0 break-words bg-gray-100 w-full mb-6 rounded">
      <div className="p-4 w-full">
        {_.size(stations.arr) ? (
          <>
            {' '}
            {_.map(allowedDashboard, (station, index) => (
              <EditTokenLine station={station} index={index} />
            ))}
          </>
        ) : (
          <div>{t('utility.empty')}</div>
        )}
      </div>
    </div>
  )
}
